import React, {useState} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {connect} from 'react-redux'

import useMediaQuery from '@mui/material/useMediaQuery'

import {updateTagFilter, initiateSearch, clearFilter} from '../../actions'

import FormControl from '@mui/material/FormControl'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'


import FilterHeader from './FilterHeader'
import FilterFooter from './FilterFooter'



const cssStyles = ({isSmallScreen}) => ({
  root: css`
    max-height: ${isSmallScreen ? '100%' : '500px'};
    min-width: 300px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding-bottom: ${isSmallScreen ? '60px' : null};
  `,
  header: css`
    padding: 20px 30px;
    width: 100%;
    background-color: #000;
    color: #fff;
  `,
  body: css`
    width: 100%;
    padding: 20px 30px;
    overflow-y: scroll;
    max-width: ${isSmallScreen ? null : '400px'};
  `,
  helperText: css`
    margin-bottom: 15px;
  `,
  control: css`
    text-transform: capitalize;
  `,
  footerContainer: css`
    width: 100%;
    position: ${isSmallScreen ? 'fixed' : null};
    bottom: 0;
    background-color: #fff;
    z-index: 50
  `
})



const genres = [
  'Pop',
  'Rock',
  'Hip-Hop',
  'rap',
  'Country',
  'R&B',
  'Folk',
  'Jazz',
  '70s',
  '80s',
  '90s',
  'Heavy Metal',
  'EDM',
  'Soul',
  'Funk',
  'Reggae',
  'Punk',
  'Classical',
  'House',
  'Techno',
  'Alternative',
  'Gospel',
  'Latin'
]



const GenreFilter = props => {

  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'))

  const styles = cssStyles({isSmallScreen})


  const {
    stateTags, 
    updateTagFilter,
    clearFilter,
    initiateSearch,
    close
  } = props


  const [tags, setTags] = useState(stateTags?.length > 0 ? stateTags.split(' ') : [])

  const lowercased = tags.map(tag => tag.toLowerCase())



  const handleChange = genre => e => {
    if (!lowercased.includes(genre.toLowerCase())) {
      setTags([...tags, genre])
    } else {
      setTags(tags.filter(tag => tag.toLowerCase() !== genre.toLowerCase()))
    }
  }



  function apply() {
    const tagsStr = tags.join(' ')

    if (tagsStr !== stateTags) {
      updateTagFilter(tagsStr)
      initiateSearch()
      close()
    }
  }



  function clear() {
    setTags([])

    if (stateTags !== '') {
      clearFilter('TAGS')
      initiateSearch()
      close()
    }
  }



  return (
    <div css={styles.root}>
      <FilterHeader title='Select Genres' clear={clear} close={close} />

      <div css={styles.body}>
        <p css={styles.helperText}>
          Not all genres are listed. If you don't see you genre, search for 
          it using the search bar. 
        </p>

        <FormControl>
          <FormGroup>
            {genres.map(genre => (
              <FormControlLabel
                key={genre}
                css={styles.control}
                label={genre}
                control={
                  <Checkbox
                    name={genre}
                    checked={lowercased.includes(genre.toLowerCase())} 
                    onChange={handleChange(genre)}
                  />
                }
              />
            ))}
          </FormGroup>
        </FormControl>
      </div>

      <div css={styles.footerContainer}>
        <FilterFooter onClick={apply} />
      </div>
    </div>
  )
}



const mapStateToProps = state => {
  return {
    stateTags: state.search.filters.tags
  }
}


const actions = {updateTagFilter, clearFilter, initiateSearch}


export default connect(mapStateToProps, actions)(GenreFilter)




